export const GET_TRANSACTION_DETAILS = "GET_TRANSACTION_DETAILS"
export const GET_TRANSACTION_DETAILS_ERR = "GET_TRANSACTION_DETAILS_ERR"
export const CLEAR_TRANSACTION_DETAILS = "CLEAR_TRANSACTION_DETAILS"